<footer class="sub-footer bg-dark">
  <div
    class="container d-flex flex-wrap justify-content-center custom-font-size"
  >
    <div
      class="col-xs-12 col-sm-8 d-flex flex-wrap justify-content-center justify-content-md-start"
    >
      <ng-container
        *ngFor="let content of nestedFirstColumn; let isLast = last"
      >
        <digital-platform-dynamic-content-wrapper
          [config]="content"
        ></digital-platform-dynamic-content-wrapper>
        <span *ngIf="!isLast" class="text-light">|</span>
      </ng-container>
    </div>
    <div
      class="col-xs-12 col-sm-4 d-flex justify-content-center justify-content-md-end align-items-center custom-margin text-light"
      data-automation-id="copyright"
    >
      © {{ currentYear }} Republic Services
    </div>
  </div>
</footer>
